export const CustomerDetailsTabs = {
    Payments: 'Payments',
    Notifications: 'Notifications',
    Contact: 'Contact',
};
